export default __webpack_public_path__ + "static/media/hexagon-challenge-completed.87882622.svg";